import { render, staticRenderFns } from "./EuthanasiaAttributes.vue?vue&type=template&id=42137030&scoped=true&"
import script from "./EuthanasiaAttributes.vue?vue&type=script&lang=js&"
export * from "./EuthanasiaAttributes.vue?vue&type=script&lang=js&"
import style0 from "./EuthanasiaAttributes.vue?vue&type=style&index=0&id=42137030&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42137030",
  null
  
)

export default component.exports